export default __webpack_public_path__ + "static/media/miku.a4467c23.svg";